import React from 'react';
import {
  Form, Row, Col, Input, Select, Button,Icon
} from 'antd';
import MiCompAPI from '../../util/api';
const { Option } = Select;
class EAD extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.form.validateFields((err, values) => {
      if (!err && this.state.isValueExists) {
        this.props.submitHandler({ ...values, account_Type_Id: this.props.item.account_Type_Id, id: this.props.item.id }, (val) => { });
      }
    });
  }
  constructor(props) {
    super(props);
    this.state = {
      isValueExists: true,
    }
    this.api = new MiCompAPI(null);
  }
  componentDidMount = () => {
    const { setFieldsValue } = this.props.form;
    const { item } = this.props;
    if (item)
      setFieldsValue({
        acc_Holder_Name: item.acc_Holder_Name, acc_Number: item.acc_Number, country_Code: item.country_Code
        , isprimaryAcc: item.isprimaryAcc
      });
  }
  handleChange = (e) => {
    if (e.target.value && e.target.value.length > 1) {
      this.api.invoke("IsValueExists/STATE/" + e.target.value + "/ABBR", "get", (data, success) => {
        if (success) {
          this.setState({ isValueExists: data.data });
        }
      });
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { item } = this.props;
    return (<Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
      <Row>
        <Col md={12} sm={24}>
          <Form.Item>
            <fieldset className="mi_input_pop">
              <legend className="legend-font">Account Holder Name</legend>
              {getFieldDecorator('acc_Holder_Name', {
                rules: [{ required: true, message: 'Please enter Account Holder Name' }, {
                  pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                  message: "It allows only Alphabets"
                }],
              })(<Input autoComplete={"nope"}  className="mi_input" type="text" place />)}
            </fieldset>
          </Form.Item>
        </Col>
        <Col md={12} sm={24}>
          <Form.Item>
            <fieldset>
              <legend className="legend-font">Account Number</legend>
              {getFieldDecorator('acc_Number', {
                rules: [{ required: true, message: 'Please enter Account Number' }],
              })(<Input autoComplete={"nope"}  className="mi_input" type="text" />)}
            </fieldset>
          </Form.Item>
        </Col>

        <Col md={12} sm={24}>
          <Form.Item>
            <fieldset>
              <legend className="legend-font">State Code</legend>
              {getFieldDecorator('country_Code', {
                rules: [{ required: true, message: 'Please enter a valid State Code' },
                {
                  pattern: /^(?!\s)(?![\s\S]*\s$)[A-Z]{2,2}$/,
                  message: "Value should be 2 character and Capital letters only(A-Z)",
                }],
              })(<Input autoComplete={"nope"}  maxLength="2" className="mi_input" type="text" onChange={this.handleChange} />)}
            </fieldset>
          </Form.Item>
          {!this.state.isValueExists ? <p style={{ color: "red", marginLeft: '10px' }}>State Code Not Valid</p> : ""}
        </Col>
        <Col md={12} sm={24}>
          <Form.Item>
            <fieldset className="mi_input_pop">
              <legend className="legend-font">Primary Account</legend>
              {getFieldDecorator('isprimaryAcc', {
                rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select a Primary Account. </span> }],
              })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input" placeholder="Please Select">
                <Option value={true} key={true}>Yes</Option>
                <Option value={false} key={true}>No</Option>
              </Select>)}
            </fieldset>
          </Form.Item>
        </Col>
      </Row>
      <Row style={{marginRight:"15px"}}>
        <Button className="mi_button_right submit-button" type="primary" htmlType="submit" onMouseEnter={(e) => e.which === 2 ? false : true}>
          Update
        </Button>{" "}
        <Button className="mi_button_right submit-button"

          onClick={() => { this.props.removeAdderss(item.id) }}
        >
          Remove
        </Button>
      </Row>
    </Form>)
  }
}
const EditAccount = Form.create()(EAD);
export default EditAccount;